import React from "react"
import ReactDOM from "react-dom"
import TodoForm from "./TodoForm"
import "./App.css"

ReactDOM.render(<TodoForm />,document.getElementById("root"))